export const STAGE1_COLUMNS = [
  {
    id: "critical",
    label: "Critical",
    subtitle: "DO FIRST",
    hint: "Most Important",
    color: "#2f9e4f",
  },
  {
    id: "important",
    label: "Important",
    subtitle: "DO NEXT",
    hint: "High Impact",
    color: "#f0a020",
  },
  {
    id: "planned",
    label: "Planned",
    subtitle: "DO LATER",
    hint: "Medium Impact",
    color: "#4a90d9",
  },
  {
    id: "low",
    label: "Low Priority",
    subtitle: "IF TIME",
    hint: "Low Impact",
    color: "#9b59b6",
  },
];

export const STAGE1_TASKS = [
  {
    id: "report",
    title: "Quarterly Report Review",
    icon: "📊",
    accent: "#2f9e4f",
  },
  {
    id: "email",
    title: "Client Email Follow-ups",
    icon: "✉️",
    accent: "#f0a020",
  },
  {
    id: "standup",
    title: "Team Standup Preparation",
    icon: "👥",
    accent: "#4a90d9",
  },
  {
    id: "website",
    title: "Website Content Update",
    icon: "🖥️",
    accent: "#9b59b6",
  },
  {
    id: "social",
    title: "Social Media Planning",
    icon: "💬",
    accent: "#2f9e4f",
  },
  {
    id: "research",
    title: "Industry Research",
    icon: "📚",
    accent: "#4a90d9",
  },
  {
    id: "skill",
    title: "Skill Learning",
    icon: "💡",
    accent: "#f0a020",
  },
  {
    id: "organize",
    title: "Organize Workspace",
    icon: "☑️",
    accent: "#94a3b8",
  },
];

export const STAGE1_PUZZLE_POINTS = 120;

export const STAGE1_MAX_TASKS_PER_COLUMN = 2;

export function countTasksInColumn(assignments, columnId, excludeTaskId = null) {
  return STAGE1_TASKS.filter(
    (task) => assignments[task.id] === columnId && task.id !== excludeTaskId
  ).length;
}

export function canPlaceTaskInColumn(assignments, taskId, columnId) {
  if (!columnId || columnId === "pool") return true;
  if (assignments[taskId] === columnId) return true;
  return (
    countTasksInColumn(assignments, columnId, taskId) <
    STAGE1_MAX_TASKS_PER_COLUMN
  );
}

export function validateTaskTriage(assignments) {
  return {
    allPlaced: STAGE1_TASKS.every((task) => assignments[task.id]),
  };
}
